import React from 'react';
import { View, StyleSheet } from 'react-native';
import FeatherIcon from './icons/FeatherIcon';
import MegaphoneIcon from './icons/MegaphoneIcon';
import SmileIcon from './icons/SmileIcon';
import StarsIcon from './icons/StarsIcon';
import TrailFlagIcon from './icons/TrailFlagIcon';
import ClockDashIcon from './icons/ClockDashIcon';

export type NoteType = 'anotacao' | 'checkin' | 'sentimento' | 'recaida' | 'relapse' | 'bill' | 'trail';

interface NoteAvatarProps {
  type: NoteType;
  size?: number;
}

const NOTE_CONFIG = {
  anotacao: {
    backgroundColor: '#E6EBF0',
    iconColor: '#669AB7',
    Icon: FeatherIcon,
  },
  checkin: {
    backgroundColor: '#E6EBF0',
    iconColor: '#669AB7',
    Icon: MegaphoneIcon,
  },
  sentimento: {
    backgroundColor: '#E6EBF0',
    iconColor: '#669AB7',
    Icon: SmileIcon,
  },
  bill: {
    backgroundColor: '#E6EBF0',
    iconColor: '#669AB7',
    Icon: StarsIcon,
  },
  trail: {
    backgroundColor: '#E6EBF0',
    iconColor: '#669AB7',
    Icon: TrailFlagIcon,
  },
  recaida: {
    backgroundColor: '#E6EBF0',
    iconColor: '#669AB7',
    Icon: ClockDashIcon,
  },
  relapse: {
    backgroundColor: '#E6EBF0',
    iconColor: '#669AB7',
    Icon: ClockDashIcon,
  },
};

export default function NoteAvatar({ type, size = 32 }: NoteAvatarProps) {
  const config = NOTE_CONFIG[type];
  const Icon = config.Icon;
  const iconSize = size / 2;

  return (
    <View
      style={[
        styles.container,
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: config.backgroundColor,
        }
      ]}
    >
      <Icon color={config.iconColor} size={iconSize} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
